import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';

const getBranches = () => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
           Pragma: 'no-cache'  //IE11
        }
    }

  // return axios.get(`http://localhost:3000/Branches.json`); 
    return http.get(`/api/v1/SMEDL/getBankBranch`,headerParams); 
};

const getAcctDtls = () => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
       
    let stateId = storage.getStateId();
    
   // return axios.get(`http://localhost:3000/AcctDtls.json`); 
    return http.get(`/api/v1/SMEDL/getAccountDetailsForm/${stateId}`,headerParams); 
};

const post = (params) => {

    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
    return http.post(`/api/v1/SMEDL/postAccountDetailsForm`,params,headerParams);
};

const getAcctList = (refNo) => {  
    
  let headerParams ={
      headers: {
        "Content-Type": "application/json",
        'Authorization':"Maybank" + " " + storage.getToken(),
        Pragma: 'no-cache'  //IE11
      }
  }
  //return axios.get(`http://localhost:3000/AccountList.json`); 
  return http.get(`/api/v1/SMEDL/getAccountList/${refNo}`,headerParams); 
};
 
export default {
    getBranches,
    post,
    getAcctDtls,
    getAcctList
};